import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import frTranslations from './locales/fr.json'
import enTranslations from './locales/en.json'
import { jeuxFr, jeuxEn } from './games'

// Les traductions des mécaniques sont agrégées depuis un fichier par mécanique
// (voir `games.ts`) et greffées sous `practice.games`, pour que seize lots
// parallèles ne se disputent pas un fichier unique.
const fr = { ...frTranslations, practice: { ...frTranslations.practice, games: jeuxFr } }
const en = { ...enTranslations, practice: { ...enTranslations.practice, games: jeuxEn } }

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    resources: {
      fr: { translation: fr },
      en: { translation: en },
    },
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'mindeia-language',
    },
  })

export default i18n
